var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thirdPartyAccess"},[_c('img',{attrs:{"src":require("../../../../assets/images/unauthorized.png")}}),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.$t('channel.dingding.thirdTip1')))]),_c('div',{staticClass:"tip2"},[_vm._v(_vm._s(_vm.$t('channel.dingding.thirdTip2')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }